import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { first } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { ContentService, AuthenticationService, NotificationService} from '../../../_services';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({ templateUrl: './episode-list.component.html' })
export class EpisodeListComponent implements OnInit {
  contentData: any = null;
  newEpisodeForm: FormGroup;
  loading = false;
  loaded = false;
  processing = false;
  showError = false;
  itemsPerPage = 10;
  pagingList = [10, 20, 40, 60, 80, 100];
  totalItems = 0;
  maxSize = 11;
  numPages = 0;
  currentPage = 1;
  page: number;
  goToPage: number;
  emptyResult = false;
  maxPageSize: number;
  episodeList: [];
  contentId = null;

  constructor(private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private authSvc: AuthenticationService,
    private contentSvc: ContentService,
    private notification: NotificationService,
    private modalService: NgbModal) {
  }

  ngOnInit(): void {
    this.contentId = this.route.snapshot.paramMap.get('id');
    this.contentData = this.loadContent(this.contentId);
    this.loadPage(1);
  }

  openModal(targetModal) {
    this.processing = false;
    this.showError = false;
    this.modalService.open(targetModal, {
      windowClass: 'modal-holder',
      size: 'lg'
    });

    this.newEpisodeForm = this.fb.group({
      title: ['', Validators.required],
      content: ['', Validators.required],
      description: ['']
    });
  }

  get f() { return this.newEpisodeForm.controls; }

  search(): void {
    this.totalItems = 0;
    this.loadPage(1);
  }

  onBack(): void {
    this.router.navigate(['/dashboard/tx/content']);
  }
  setPage(pageNo: number): void {
    this.currentPage = pageNo;
    this.loadPage();
  }

  pageChanged(event: any): void {
    this.page = event.page;
    if (this.page != this.currentPage) {
      this.loadPage(this.page);
    }
  }

  itemsPerPageChange(deviceValue) {
    this.itemsPerPage = deviceValue;
    this.loadPage(1);
  }

  deleteEpisode(episode){
    if (confirm("Are you sure to delete this episode?")) {
      this.contentSvc.deleteEpisode(episode.id).subscribe(data => {
        if (data.status == 1) {
          this.notification.showSuccess("Episode deleted successfully!", "Delete Episode");
          this.loadPage(1);
        } else {
          this.notification.showError("Error deleting episode, please try again later.", "Error");
        }
      })
    }
  }
  onSubmit() {
    this.processing = true;
    var newDataParam = this.newEpisodeForm.getRawValue();
    if (this.newEpisodeForm.valid) {
      if (confirm("Are you sure to add the content episode now?")) {
        this.contentSvc.addEpisode(this.contentId, newDataParam).subscribe(data => {
          if (data !== null) {
            if (data.status == 1) {
              this.notification.showSuccess("Episode added successfully!", "New Meta");
              this.modalService.dismissAll();
              this.loadPage(1);
            } else {
              this.notification.showError(data.msg, "Fail to add");
            }
          } else {
            this.notification.showError("Failed to add episode, please try again later.", "Fail to add");
          }
        })
      }
      this.processing = false;
    } else {
      this.showError = true;
      this.notification.showError("Some fields are missing", "Add failed");
      this.processing = false;
    }
  }

  private loadPage(page = null) {
    this.loading = true;
    this.episodeList = [];
    let params = this.formParam(page);

    // get page of items from api
    this.contentSvc.getAllEpisode(this.contentId, params).pipe(first()).subscribe(data => {
      if (data !== null) {
        this.loading = false;
        this.emptyResult = false;
        this.totalItems = data.data.total;
        this.episodeList = data.data.list;
        this.currentPage = data.data.page + 1;
        this.maxPageSize = Math.ceil(data.data.total / data.data.pageSize) < 1 ? 1 : Math.ceil(data.data.total / data.data.pageSize);
      } else {
        this.loading = false;
        this.emptyResult = true;
        this.maxPageSize = 0;
        this.notification.showWarning("There is no record.", "Empty Result");
      }
    });
  }

  private formParam(page = null) {
    let params = {
      pageSize: this.itemsPerPage || 20,
      page: page == null ? this.currentPage - 1 : page - 1,
    }
    return params;
  }

  private loadContent(id){
    this.contentSvc.getContent(id).subscribe(data => {
      this.contentData = data
      this.loaded = true;
    });
  }
}
